import { render } from "./fqc.vue?vue&type=template&id=ff99db26&scoped=true"
import script from "./fqc.vue?vue&type=script&lang=js"
export * from "./fqc.vue?vue&type=script&lang=js"

import "./fqc.vue?vue&type=style&index=0&id=ff99db26&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff99db26"]])

export default __exports__